<template>
	<div>
		<div class="d-flex align-center">
			<v-autocomplete
				class="mr-4 filter-item"
				:value="filters.clientIds"
				:items="clients"
				:search-input.sync="clientSearch"
				outlined
				dense
				clearable
				hideDetails
				item-text="name"
				item-value="id"
				label="Клиент"
				multiple
				:filter="filterByText"
				:loading="loading.clients"
				@input="onClientSelect"
			>
				<template v-slot:item="{ item }">
					<span><sup>{{ item.id }}</sup> {{ item.name }}</span>
				</template>
			</v-autocomplete>
			<v-select
				class="mr-4 filter-item"
				:items="clientsTariffs"
				item-text="text"
				item-value="value"
				label="Тариф"
				:value="filters.tariffId"
				clearable
				dense
				outlined
				hide-details
				@change="updateFilters('tariff_id', $event)"
			/>
			<v-menu
				v-model="monthMenu"
				:close-on-content-click="false"
				offset-y
				max-width="280px"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mr-4 filter-item month-filter"
						:value="selectedMonth"
						label="Месяц"
						readonly
						dense
						outlined
						hide-details
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker
					v-model="selectedMonth"
					type="month"
					@input="selectMonth"
				/>
			</v-menu>
			<v-checkbox
				v-model="showInactive"
				label="Показать также неактивных клиентов"
				dense
				hide-details
				@change="toggleActive"
			/>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { filterByText } from '@/function/filter'

export default {
	name: 'filters',

	props: {
		filters: {
			type: Object,
			required: true
		},
		loading: {
			type: Object,
			required: true
		},
		clientsTariffs: {
			type: Array,
			required: true
		}
	},
	data () {
		return {
			menuDatePicker: false,
			clientSearch: '',
			monthMenu: false,
			showInactive: false
		}
	},
	computed: {
		...mapState({
			clients: state => state.clients
		}),
		selectedMonth () {
			if (!this.filters?.month) return ''

			const month = String(this.filters.month)

			return `${month.slice(0, 4)}-${month.slice(4, 6)}`
		}
	},

	methods: {
		onClientSelect (val) {
			this.updateFilters('client_ids', val)
			this.clientSearch = ''
		},
		updateFilters (name, value) {
			this.$emit('update-filters', { [name]: value })
		},
		filterByText,
		selectMonth (value) {
			this.monthMenu = false
			const month = value.replace('-', '')

			this.updateFilters('month', month)
		},
		toggleActive (value) {
			this.updateFilters('only_active_clients', value ? '0' : '1')
		}
	}
}
</script>

<style scoped lang="scss">
.filter-item {
	max-width: 300px;
}

.filter-card {
	margin-top: 16px;
}

.filter-range {
	display: flex;
	gap: 8px;
}

.filter-range .v-text-field {
	max-width: 200px;
}
</style>
